// extracted by mini-css-extract-plugin
export default {"code":"M_b9"};